




































































































































import { Entity } from '@/models/entity';
import { EntityStatusService } from '@/services/entity-status-service';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import ConfirmModal from '@/components/display/confirm-modal.vue';
import { Entities, Product, ProductStatus, ProductType } from '@/api';
import ConfirmDraftActionbar from '@/components/confirm-draft-actionbar.vue';

@Component({
	computed: {
		Entities() {
			return Entities;
		},
		ProductType() {
			return ProductType;
		},
		ProductStatus() {
			return ProductStatus;
		},
	},
	components: { ConfirmDraftActionbar, ConfirmModal },
})
export default class EntityHeader<T extends Entity> extends Vue {
	@Prop({ required: true, type: Object })
	public readonly product!: Product;

	@Prop({ required: true, type: String })
	public readonly title!: string;

	@Prop({ required: true, type: Object })
	public readonly entity!: T;

	@Prop({ required: true, type: Object })
	public entityStatusService!: EntityStatusService<T>;

	@Prop({ required: true, type: String })
	public entityTypeName!: string;

	@Prop({ required: false, type: Array })
	public removalReasons?: string[];

	@Prop({ required: false, type: Array })
	public cancelReasons?: string[];

	@Emit('moveToSignOff')
	public onMoveToSignOff(): T {
		return this.entity;
	}

	@Emit('signOff')
	public onSignOff(): T {
		return this.entity;
	}

	@Emit('install')
	public onInstall(): T {
		return this.entity;
	}

	@Emit('provision')
	public onProvision(): T {
		return this.entity;
	}

	@Emit('changeHardware')
	public onChangeHardware(): T {
		return this.entity;
	}

	@Emit('edit')
	public onEdit(): T {
		return this.entity;
	}

	@Emit('remove')
	public onRemove(params: {
		modalId?: string;
		actionReason?: string | null;
	}): { modalId?: string; entity: T; actionReason?: string | null } {
		return { modalId: params.modalId, entity: this.entity, actionReason: params.actionReason };
	}

	@Emit('cancel')
	public onCancel(params: {
		modalId?: string;
		actionReason?: string | null;
	}): { modalId?: string; entity: T; actionReason?: string | null } {
		return { modalId: params.modalId, entity: this.entity, actionReason: params.actionReason };
	}

	@Emit('reload')
	public onReload(): void {}

	public confirmRemovalModalId: string = `confirmRemovalModal-${this.entity.id}`;
	public confirmCancellationModalId: string = `confirmCancellationModal-${this.entity.id}`;

	public confirmRemove(): void {
		this.$bvModal.show(this.confirmRemovalModalId);
	}

	public confirmCancel(): void {
		this.$bvModal.show(this.confirmCancellationModalId);
	}

	private get service(): EntityStatusService<T> {
		return this.entityStatusService;
	}

	public get status(): string {
		return this.service.entityStatus;
	}

	public get readyForSignOff(): boolean {
		return this.service.entityReadyForSignOff();
	}

	public get entityNotLiveYet(): boolean {
		return this.service.entityNotLiveYet;
	}

	public get entityPreSignOff(): boolean {
		return this.service.entityPreSignOff;
	}

	public get canRemoveEntity(): boolean {
		return this.service.canRemoveEntity;
	}

	public get entityInactive(): boolean {
		return this.service.entityInactive;
	}

	private dismiss(modal: string) {
		setTimeout(() => this.$bvModal.hide(modal), 1);
	}
}
